// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyC4H1d_lSm8RpO2IuvDVjN-C3WrY1BLeBQ",
    authDomain: "drbeen-9d4d8.firebaseapp.com",
    databaseURL: "https://drbeen-9d4d8.firebaseio.com",
    projectId: "drbeen-9d4d8",
    storageBucket: "drbeen-9d4d8.appspot.com",
    messagingSenderId: "953675125069"
  },
  stichApiKey : "drbeen-stage-zujks",
  paytm_merchand_id : "mYyZtT85923772350515",
  paytm_account_secret : "GlBJcA0@azDN@G4R"
  //stichApiKey : "mobile-dwlzy"
  
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
